import img1 from './assets/images/header/img1.png';
import img2 from './assets/images/header/img2.png';
import img3 from './assets/images/header/img3.png';
import img4 from './assets/images/header/img4.png';
import img5 from './assets/images/header/img5.png';
import img6 from './assets/images/header/img6.png';
import img7 from './assets/images/header/img7.png';
import img8 from './assets/images/header/img8.png';
import img9 from './assets/images/header/img9.png';
import img10 from './assets/images/header/img10.png';


const HeaderNav = [
  {
    path: "/",
    name: "Dashboard\n& Analytics",
    img: img1,
  },
  {
    path: "/sample-management",
    name: "Sample\nManagement",
    img: img2,
  },
  {
    path: "/instrument-management",
    name: "Instrument\nManagement",
    img: img3,
  },
  {
    path: "/certificate-generation",
    name: "Certificate\nGeneration",
    img: img4,
  },
  {
    path: "/customer-management",
    name: "Customer\nManagement",
    img: img5,
  },
  {
    path: "/quality-management/general-requirement/imperiality",
    name: "Quality Management\n(QMS)",
    img: img6,
  },
  {
    path: "/reports-generation/sample-report",
    name: "Reports\nGeneration",
    img: img7,
  },
  {
    path: "/audit-traceability-logs",
    name: "Audit & Traceability\nLogs",
    img: img8,
  },
  {
    path: "/user-management-modal",
    name: "User\nManagement",
    img: img9,
  },
  {
    path: "/security-compliance",
    name: "Security &\nCompliance",
    img: img10,
  },
];


export default HeaderNav;
